var _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8004,
    cy: 8.4,
    rx: 8.4,
    ry: 8.4,
    fill: "#FEBA57"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2008,
    cy: 30.6,
    rx: 8.4,
    ry: 8.4,
    fill: "#026D7B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0006,
    cy: 16.7999,
    rx: 8.4,
    ry: 8.4,
    fill: "#787EFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6002,
    cy: 34.8,
    rx: 8.4,
    ry: 8.4,
    fill: "#FEBA57"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.2008,
    cy: 12.0001,
    r: 8.4,
    fill: "#4BB7BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4921 62.6141L6.8225 47.9141C2.34806 44.391 4.8393 37.2 10.5343 37.2H61.0633C66.7736 37.2 69.2554 44.4231 64.751 47.9329L45.8849 62.6329C45.7065 62.7719 45.5211 62.9001 45.3297 63.0173V66C45.3297 69.3137 42.6434 72 39.3297 72H32.0545C28.7408 72 26.0545 69.3137 26.0545 66V63.007C25.8605 62.8873 25.6726 62.7562 25.4921 62.6141Z",
    fill: "#ED7EA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d9cd6c19d9180ea8a83e58cf0a327225.svg";
export { ForwardRef as ReactComponent };